import { Transform } from 'class-transformer';
import {
  IsNotEmpty,
  IsUUID,
  IsString,
  IsInt,
  IsBoolean,
  IsIn,
} from 'class-validator';

export class UpdateValidatorDto {
  @IsUUID(undefined, { groups: ['min_hiring_day', 'other'] })
  @IsNotEmpty({ groups: ['min_hiring_day', 'other'] })
  validator_id: string;

  @IsUUID(undefined, { groups: ['min_hiring_day', 'other'] })
  @IsNotEmpty({ groups: ['min_hiring_day', 'other'] })
  eventTypeId: string;

  @IsString({ groups: ['min_hiring_day', 'other'] })
  @IsNotEmpty({ groups: ['min_hiring_day', 'other'] })
  type: string;

  @IsInt({
    message: 'Количечтво дней должно быть целым числом',
    groups: ['other'],
  })
  @Transform(({ value }) => value && +value)
  @IsNotEmpty({
    message: 'Вы забыли ввести количество дней',
    groups: ['other'],
  })
  days_count: number;

  @IsBoolean({ groups: ['other'] })
  @Transform(({ value }) => value && [true, 'enabled', 'true'].includes(value))
  @IsNotEmpty({ groups: ['other'] })
  working_days_only: boolean;

  @IsIn(['eq', 'ge', 'gt', 'le', 'lt'], { groups: ['min_hiring_day'] })
  @IsString({ groups: ['min_hiring_day'] })
  @IsNotEmpty({ groups: ['min_hiring_day'] })
  operation: string;
}
